import React, { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import { COMMON_CONSTANTS } from '../constants/Common'
import "leaflet/dist/leaflet.css";
const { config: { tiler_api_key } } = COMMON_CONSTANTS

const mapTilerApiKey = process.env.REACT_APP_MAP_TILER_API_KEY || tiler_api_key

const mapUrl = `https://api.maptiler.com/maps/bright/{z}/{x}/{y}.png?key=${mapTilerApiKey}`

// ✅ Fix marker icon issue using direct URLs (reliable)
L.Icon.Default.mergeOptions({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// ✅ Component to re-center map on position change
function RecenterMap({ position }) {
  const map = useMap();

  useEffect(() => {
    if (position && position.length === 2) {
      map.setView(position);
    }
  }, [position, map]);

  return null;
}

export default function LocationPicker({ setLocation }) {
  const [position, setPosition] = useState([26.9124, 75.7873]); // Default Jaipur
  const markerRef = useRef(null);

  // ✅ Get user's current location on mount
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setPosition([latitude, longitude]);
        setLocation({ latitude, longitude });
      },
      (err) => {
        console.error("Geolocation error:", err);
      }
    );
  }, [setLocation]);

  return (
    <MapContainer center={position} zoom={17} style={{ height: "60vh", width: "100%" }}>
      <TileLayer
        url={mapUrl}
        attribution='&copy; <a href="https://www.maptiler.com/">MapTiler</a> & OpenStreetMap contributors'
      />

      <RecenterMap position={position} />

      {/* ✅ Render marker only if position is valid */}
      {position && position.length === 2 && (
        <Marker
          position={position}
          draggable={true}
          ref={markerRef}
          eventHandlers={{
            dragend() {
              const marker = markerRef.current;
              if (marker) {
                const { lat, lng } = marker.getLatLng();
                setPosition([lat, lng]);
                setLocation({ latitude: lat, longitude: lng });
              }
            },
          }}
        />
      )}
    </MapContainer>
  );
}
